module.exports = __webpack_public_path__ + "img/system_off.56147691.png";